const requiredEnvVars = [
  'REACT_APP_SERVER_URL',
  'REACT_APP_BACKEND_URL',
];

const config = {
  serverUrl: process.env.REACT_APP_ENV === 'development' 
    ? process.env.REACT_APP_BACKEND_URL_LOCAL 
    : process.env.REACT_APP_SERVER_URL,
  backendUrl: process.env.REACT_APP_BACKEND_URL,
};

// Validate required environment variables
requiredEnvVars.forEach(envVar => {
  if (!process.env[envVar]) {
    throw new Error(`Missing required environment variable: ${envVar}`);
  }
});

export default config; 